<template>
  <div :class="cssClass" @click.self="closePopup">
    <div class="popup-container">
      <div v-if="showCloseIcon" class="close-icon" @click="closePopup">
          <div class="icon-close-pos"></div>
      </div>
      <div class="content">
        <h3>{{ translationPlaceholders && translationPlaceholders.title ? $t(title, translationPlaceholders.title ) : $t(title) }}</h3>
        <p>{{ translationPlaceholders && translationPlaceholders.description ? $t(description, translationPlaceholders.description ) : $t(description) }}</p>
        <ul v-if="showContactList" class="list-icon-pos">
            <li class="phone" v-if="phone && phone_url"><a :href="'tel:' + phone_url" target="_blank" rel="external noopener">{{phone}}</a></li>
            <li class="email" v-if="email"><a :href="'mailto:' + email" target="_blank" rel="external noopener">{{email}}</a></li>
            <li class="url" v-if="url"><a :href="url" target="_blank" rel="external noopener">{{url}}</a></li>
        </ul>
        <component :is="formComponent" v-bind="formProps" @form_submission_successful="formSubmissionSuccessful" />
      </div>
    </div>
  </div>
</template>

<script>
import { usePopupStore } from '@/stores/utils/popup';
import { mapActions } from 'pinia';
import i18n from '@/plugins/i18n';

export default {
    name: 'PopupForm',
    props: {
        title: String,
        description: String,
        formComponent: Object,
        showCloseIcon: {
            type: Boolean,
            default: true
        },
        showContactList: {
            type: Boolean,
            default: false
        },
        cssClass: {
            type: String,
            default: 'popup-type-1'
        },
        formProps: {
            type: Object,
            default: () => ({})
        },
        translationPlaceholders: {
            type: Object,
            default: () => ({})
        },
        onFormSuccess: {
            type: Function,
            required: false
        }
    },
    data() {
        return {
            phone_nl: process.env.VUE_APP_PHONE_NL || process.env.VUE_APP_PHONE || false,
            phone_intl: process.env.VUE_APP_PHONE || false,
            phone_url: process.env.VUE_APP_PHONE_URL || false,
            email: process.env.VUE_APP_EMAIL || false,
            url: process.env.VUE_APP_URL_MAIN || false,
        }
    },
    computed: {
        currentLocale() {
            return i18n.global.locale === 'nl' ? 'nl' : 'en';
        },
        phone() {
            return this.currentLocale === 'nl' ? this.phone_nl : this.phone_intl;
        }
    },
    methods: {
        ...mapActions(usePopupStore, ['closePopup']),
        formSubmissionSuccessful() {
            this.closePopup();

            if( this.onFormSuccess ) {
                this.onFormSuccess();
            }
        }
    }
};
</script>
